import { render, staticRenderFns } from "./GameHistory.vue?vue&type=template&id=190c67b2"
import script from "./GameHistory.vue?vue&type=script&lang=js"
export * from "./GameHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('190c67b2')) {
      api.createRecord('190c67b2', component.options)
    } else {
      api.reload('190c67b2', component.options)
    }
    module.hot.accept("./GameHistory.vue?vue&type=template&id=190c67b2", function () {
      api.rerender('190c67b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/history/components/GameHistory.vue"
export default component.exports